import {
  _isMobile,
  _isOnScreen,
  _once,
  configureShadowArea,
  configureVerticalShadowArea,
} from '../../utils';

_isOnScreen(
  '.header__beacon',
  () => {
    document.querySelector('.tools-navigation').classList.remove('fixed');
  },
  {},
  () => {
    document.querySelector('.tools-navigation').classList.add('fixed');
  },
);

_isOnScreen('.tools-navigation', () => {
  let scrollArea = document.querySelector('.tools-navigation__scroll-area');
  if (_isMobile()) {
    configureShadowArea(scrollArea);
  } else {
    configureVerticalShadowArea(scrollArea);
  }

  _once(() => {
    window.addEventListener('resize', function () {
      if (_isMobile()) {
        configureShadowArea(scrollArea);
        scrollArea.scrollTop = 0;
      } else {
        configureVerticalShadowArea(scrollArea);
        scrollArea.scrollLeft = 0;
      }
    });

    scrollArea.addEventListener('scroll', function () {
      if (_isMobile()) {
        configureShadowArea(scrollArea);
      } else {
        configureVerticalShadowArea(scrollArea);
      }
    });
  })();
});

const images = [
  'https://essayshark.com/w3t_avatar/writer/251/mastermindwriterx128.webp',
  'https://essayshark.com/w3t_avatar/writer/291/aqademiar-tpnx128.webp',
  'https://essayshark.com/w3t_avatar/writer/147/octoberbabyx128.webp',
  'https://essayshark.com/w3t_avatar/writer/330/amaninzemx128.webp',
  'https://essayshark.com/w3t_avatar/writer/157/dockamenx128.webp',
  'https://essayshark.com/w3t_avatar/writer/133/nunziolinx128.webp',
  'https://essayshark.com/w3t_avatar/writer/346/professorultimatex128.webp',
  'https://essayshark.com/w3t_avatar/writer/248/cathykathyx128.webp',
  'https://essayshark.com/w3t_avatar/writer/416/techpro12x128.webp',
];

let currentIndex = 1;
const imgElement = document.querySelector('.tools-navigation__writer-avatar');
const onlineStatus = document.querySelector('.tools-navigation__online-status');
function changeImage() {
  // Fade out current image
  imgElement.classList.add('fade-out');
  onlineStatus.classList.add('fade-out');
  setTimeout(() => {
    currentIndex = (currentIndex + 1) % images.length;
    imgElement.src = images[currentIndex];
    // Fade the image back in
    imgElement.classList.remove('fade-out');
    onlineStatus.classList.remove('fade-out');
  }, 200);
}

// Change the image every 10 seconds
setInterval(changeImage, 10000);
